import { mergeBaseUri } from '@cian/http-api/shared';

import { IAgentSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { filterServerResponse } from './helpers';
import { IMakeRequest } from '../utils/make_request';

interface IGetAgentDataForCardResponse {
  data: {
    agent: IAgentSchema | null;
  } | null;
  status: 'ok';
}

export interface IGetAgentDataForCardOptions {
  apiBaseUrl: string;
  realtyUserId: number;
  subdomain: string;
}

export function getAgentDataForCard(
  makeRequest: IMakeRequest,
  options: IGetAgentDataForCardOptions,
): Promise<IGetAgentDataForCardResponse> {
  return makeRequest({
    method: 'GET',
    uri: mergeBaseUri(options.apiBaseUrl.replace('www', options.subdomain), {
      path: `/cian-api/site/v1/get-agent-data-for-card/`,
      query: `realtyUserId=${options.realtyUserId}`,
    }),
  })
    .then(filterServerResponse)
    .then(response => JSON.parse(response.responseBody));
}
